import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"],
  _excluded3 = ["data"],
  _excluded4 = ["data"],
  _excluded5 = ["data"],
  _excluded6 = ["data"],
  _excluded7 = ["data"],
  _excluded8 = ["data"],
  _excluded9 = ["data"],
  _excluded10 = ["data"],
  _excluded11 = ["data"],
  _excluded12 = ["data"];
/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallOptInRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import { useQuery, useLazyQuery, useSuspenseQuery } from 'data-fetching-client';
import * as Queries from './StandardizedInstallOptInRpc.dfc.new';
export function useAddStandardizedInstallOptInQuery(options) {
  const _useQuery = useQuery(Queries.ADD_STANDARDIZED_INSTALL_OPT_IN_QUERY, options),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    addStandardizedInstallOptIn: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useAddStandardizedInstallOptInLazyQuery(options) {
  const [getter, _ref] = useLazyQuery(Queries.ADD_STANDARDIZED_INSTALL_OPT_IN_QUERY, options);
  const {
      data
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    addStandardizedInstallOptIn: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useAddStandardizedInstallOptInSuspenseQuery(options) {
  const _useSuspenseQuery = useSuspenseQuery(Queries.ADD_STANDARDIZED_INSTALL_OPT_IN_QUERY, options),
    {
      data
    } = _useSuspenseQuery,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery, _excluded3);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    addStandardizedInstallOptIn: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useRemoveStandardizedInstallOptInQuery(options) {
  const _useQuery2 = useQuery(Queries.REMOVE_STANDARDIZED_INSTALL_OPT_IN_QUERY, options),
    {
      data
    } = _useQuery2,
    rest = _objectWithoutPropertiesLoose(_useQuery2, _excluded4);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    removeStandardizedInstallOptIn: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useRemoveStandardizedInstallOptInLazyQuery(options) {
  const [getter, _ref2] = useLazyQuery(Queries.REMOVE_STANDARDIZED_INSTALL_OPT_IN_QUERY, options);
  const {
      data
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded5);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    removeStandardizedInstallOptIn: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useRemoveStandardizedInstallOptInSuspenseQuery(options) {
  const _useSuspenseQuery2 = useSuspenseQuery(Queries.REMOVE_STANDARDIZED_INSTALL_OPT_IN_QUERY, options),
    {
      data
    } = _useSuspenseQuery2,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery2, _excluded6);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    removeStandardizedInstallOptIn: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetStandardizedInstallOptInQuery(options) {
  const _useQuery3 = useQuery(Queries.GET_STANDARDIZED_INSTALL_OPT_IN_QUERY, options),
    {
      data
    } = _useQuery3,
    rest = _objectWithoutPropertiesLoose(_useQuery3, _excluded7);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getStandardizedInstallOptIn: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetStandardizedInstallOptInLazyQuery(options) {
  const [getter, _ref3] = useLazyQuery(Queries.GET_STANDARDIZED_INSTALL_OPT_IN_QUERY, options);
  const {
      data
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded8);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getStandardizedInstallOptIn: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetStandardizedInstallOptInSuspenseQuery(options) {
  const _useSuspenseQuery3 = useSuspenseQuery(Queries.GET_STANDARDIZED_INSTALL_OPT_IN_QUERY, options),
    {
      data
    } = _useSuspenseQuery3,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery3, _excluded9);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getStandardizedInstallOptIn: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useBatchCheckStandardizedInstallQuery(options) {
  const _useQuery4 = useQuery(Queries.BATCH_CHECK_STANDARDIZED_INSTALL_QUERY, options),
    {
      data
    } = _useQuery4,
    rest = _objectWithoutPropertiesLoose(_useQuery4, _excluded10);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    batchCheckStandardizedInstall: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useBatchCheckStandardizedInstallLazyQuery(options) {
  const [getter, _ref4] = useLazyQuery(Queries.BATCH_CHECK_STANDARDIZED_INSTALL_QUERY, options);
  const {
      data
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded11);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    batchCheckStandardizedInstall: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useBatchCheckStandardizedInstallSuspenseQuery(options) {
  const _useSuspenseQuery4 = useSuspenseQuery(Queries.BATCH_CHECK_STANDARDIZED_INSTALL_QUERY, options),
    {
      data
    } = _useSuspenseQuery4,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery4, _excluded12);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    batchCheckStandardizedInstall: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}